export const STATUS_LABEL = {
  trialing: "ทดลองใช้",
  active:   "ใช้งานอยู่",
  expired:  "หมดอายุ",
  canceled: "ยกเลิกแล้ว",
  past_due: "ค้างชำระ",
}

export const STATUS_COLOR = {
  trialing: "yellow",
  active:   "green",
  expired:  "red",
  canceled: "gray",
  past_due: "orange",
}

export function trialDaysLeft(subscription) {
  if (!subscription?.trial_ends_at) return 0
  const ms = new Date(subscription.trial_ends_at) - new Date()
  return Math.max(0, Math.ceil(ms / 86400000))
}
